import styled from 'styled-components';

export const Container = styled.div`
  width: 100vw;
  min-width: 148mm; /* A5 width */
  min-height: 210mm; /* A5 height */
  display: none;
  page-break-inside: avoid;

  @media print {
    & {
      display: flex;
      margin: 0;
      padding: 0;
      width: 148mm; /* A5 width */
      min-width: 148mm; /* A5 width */
      min-height: 210mm; /* A5 height */
      height: auto;
      page-break-inside: avoid;
    }
  }
`;

export const Main = styled.div`
  page-break-inside: avoid;
  min-width: 148mm; /* A5 width */
  min-height: 210mm; /* A5 height */

  > div {
    align-items: center;
    flex-direction: column;
    width: 100%;
    page-break-inside: avoid;

    hr {
      border: 0;
      width: 0;
      display: none;
    }

    &:not(:first-child) {
      margin-top: 40px;
      page-break-before: always;

      hr {
        border: none;
        border-top: 1px dashed #000;
        height: 1px;
        width: 100%;
        margin-bottom: 40px;
        display: block;
      }
    }
  }
`;

export const Ticket = styled.table`
  border-collapse: collapse;
  height: auto;
  max-height: 450px;
  width: 700px;
  margin: auto;
  page-break-inside: avoid;

  td {
    border: 1px solid #000;
  }

  .logo {
    width: 112.5px;
    height: 80px;

    display: flex;
    justify-content: center;

    img {
      width: 80px;
      height: 80px;
    }
  }

  .protocol {
    width: 350px;
  }

  .number {
    width: 118px;
  }
`;

export const Td = styled.td`
  height: 40px;

  div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    height: 100%;
    width: 100%;
    margin: 0px;
    padding: 0px;

    span {
      font-size: 11px;
      margin-left: 8px;
      margin-right: 0px;
      align-self: flex-start;
    }

    strong {
      font-size: 13px;
      align-self: center;
      margin-bottom: 3px;
    }
  }

  .header {
    width: 485px;
    justify-content: center;

    strong {
      font-size: 16px;
    }
  }

  .user {
    width: 70%;
    padding-left: 8px;
  }
`;

export const TdTable = styled.div`
  width: 100%;
  min-width: 55mm; /* Further reduced minimum width */
  // height: auto;
  min-height: 80mm; /* Further reduced minimum height */
  max-height: none; /* Remove max-height restriction */
  page-break-inside: avoid;
  overflow: visible;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  padding: 10px;
  table {
    border: 0;
    border-spacing: 0px;
    page-break-inside: avoid;
    table-layout: fixed;
    width: 100%;
    min-height: 65mm; /* Further reduced minimum height for table content */

    tbody {
      min-height: 50mm; /* Further reduced minimum height for tbody */
      vertical-align: top;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
    }

    tr {
      height: 20px; /* Fixed height for table rows */
      display: table;
      width: 100%;
      table-layout: fixed;
    }

    th {
      font-size: 11px;
      border-bottom: 1px solid #000;
      padding: 2px 4px;
      vertical-align: top;
    }

    td {
      border: 0;
      font-size: 11px;
      padding: 2px 4px;
      vertical-align: top;
    }

    .cod {
      text-align: center;
      width: 12%;
      min-width: 80px;

      svg {
        max-width: 100%;
        height: 30px;
        display: block;
        margin: 0 auto;
      }
    }

    .document {
      text-align: left;
      width: 36%;
    }

    .comp,
    .deadline,
    .price {
      text-align: center;
      width: 8%;
    }

    .obs {
      text-align: left;
      width: 28%;
    }
  }
`;

export const CompanyInfo = styled.div`
  width: 100%;
  font-size: 11px;
  text-align: center;
  margin-top: 5px;
  page-break-before: avoid;
  page-break-inside: avoid;

  strong,
  span {
    margin: 5px;
  }
`;
